import type { FaireProductEntity } from "../../entity_types/product";

export const p_6m6uh95yf7: FaireProductEntity = {
  token: "p_6m6uh95yf7",
  type: "product",
  name: "Crown Point Organic Espresso, 5 lb - Organic",
  brandToken: "b_3angyj4q6y",
  brandName: "Sightglass Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/6138d821a079519740794abf26635e1437a3bf467a3b8e6f7492d2174cb6b756.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5a8daf23401c225ad94b6f84cb1874095ddbc90bcabcea4f30747792f8bfb175.webp",
    "https://cdn.faire.com/fastly/f928e7395a8d2156c80323692c8f5924e5a19ed48ce8213e554f99ffe6715888.webp"
  ],
  priceDollars: 75.5,
  description: "Crown Point Espresso // This espresso roast was crafted to pair perfectly with milk, and offer a blend for all types of coffee drinkers. This blend has a base of seasonally rotating Central and South American coffees and showcases a lively, full-bodied sweetness, clean candy-like fruit flavors, and an elegant lingering finish.\nCCOF Certified Organic\nTaste Notes // Raspberry, Chocolate, Butterscotch\nRoast Profile // Espresso\nRecommended Brew Method // Espresso, French Press, Aeropress\nShelf Life // All our whole bean coffees are roasted fresh to order and stamped with the roast date. We encourage selling the coffee within 90 days of the printed date for optimal freshness and flavor. If you have questions about freshness or how to brew this coffee, send us a note or email [redacted-email]!",
  tags: [],
  msrpDollars: 151,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:37.735Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
